const initialState = {
  prorationDate: '',
  isFetching: false,
  reducedPrice: 0,
  coupon: '',
  error: false
};

export default function upgradeSubscription(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
